import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { UserSearchList } from './types/UserSearchList';
import { APIV2_URL } from './constants';

export interface Query {
  limit?: number;
  offset?: number;
  city?: string;
  countryCode?: string;
  lang?: string;
}

export type GetSavedSearchesCall = (
  userId: number,
  query?: Query,
) => Promise<{ data: UserSearchList }>;

export default (makeCall: MakeCall) => (userId: number, query?: Query) =>
  makeCall<UserSearchList>('GET', `${APIV2_URL}/user/${userId}/searches`, {
    query,
  });
